import { module as modujs } from "modujs";
import { gsap } from "gsap";
import { outerWidth } from "../helpers";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.gsapInstances = [];
		this.$clones = [];
		this.defaultSpeed = 50; // Pixels per second
		this.isPaused = false;
	}

	init() {
		this.speed = this.getData("speed") ? this.getData("speed") : this.defaultSpeed;

		this.$wrapper = this.$("wrapper")[0];
		this.$content = this.$("content")[0];

		this._resizeHandler = this.resize.bind(this);
		this._mouseEnterHandler = this.pause.bind(this);
		this._mouseLeaveHandler = this.resume.bind(this);

		window.addEventListener("resize", this._resizeHandler);
		this.el.addEventListener("mouseenter", this._mouseEnterHandler);
		this.el.addEventListener("mouseleave", this._mouseLeaveHandler);

		this.resizeDebounce();
	}

	resize() {
		if (this.resizeTimeout != undefined) {
			this.resizeTimeout.kill();
		}

		this.resizeTimeout = gsap.delayedCall(0.3, () => {
			this.resizeDebounce();
		});
	}

	resizeDebounce() {
		if (this.$clones) {
			this.$clones.forEach(($clone) => {
				$clone.remove();
			});
		}

		this.marqueeWidth = outerWidth(this.el);
		this.contentWidth = outerWidth(this.$content);

		if (this.contentWidth > 0) {
			var diff = this.marqueeWidth / this.contentWidth;
			var duplications = Math.ceil(diff);

			for (var x = 0; x < duplications; x++) {
				var $clone = this.$wrapper.appendChild(this.$content.cloneNode(true));
				this.$clones.push($clone);
			}
		}

		this.restartTween();
	}

	restartTween() {
		if (this.tween) {
			this.tween.kill();
			this.tween.targets().forEach((target) => {
				gsap.set(target, { clearProps: "x" }); // Only clear the x property
			});
		}

		this.tween = gsap.to(this.$("wrapper")[0], {
			x: -outerWidth(this.$("content")[0]),
			repeat: -1,
			ease: "none",
			duration: outerWidth(this.$("content")[0]) / this.speed,
			paused: this.isPaused, // Start paused if it was paused before resize
		});

		this.gsapInstances.push(this.tween);
	}

	pause() {
		if (this.tween && !this.isPaused) {
			this.tween.pause();
			this.isPaused = true;
		}
	}

	resume() {
		if (this.tween && this.isPaused) {
			this.tween.resume();
			this.isPaused = false;
		}
	}

	destroy() {
		window.removeEventListener("resize", this._resizeHandler);
		this.el.removeEventListener("mouseenter", this._mouseEnterHandler);
		this.el.removeEventListener("mouseleave", this._mouseLeaveHandler);

		this.gsapInstances.forEach((instance) => {
			if (instance) {
				if (instance.scrollTrigger) {
					instance.scrollTrigger.kill();
				}
				instance.kill();
			}
		});

		this.gsapInstances = [];
	}
}
